import env from './env';

const MY_BOX = 'mybox';
const UPGRADE_PAGE_URL = `${env.envURL}/upgrade-confirmation?referrer=${MY_BOX}`;

const PRODUCT_SUBS_TYPES = {
  REPLACEMENT: 'REPLACEMENT_PRODUCT',
  SUBSCRIPTION: 'SUBSCRIPTION_PRODUCT',
};

export { MY_BOX, UPGRADE_PAGE_URL, PRODUCT_SUBS_TYPES };
